import { AxiosResponse } from 'axios';
import ServiceClient from './shared/service-client/ServiceClient';

export interface ConnectToken {
  accessToken: string;
  expiresIn: number;
}

export interface ConnectRefreshToken {
  refreshToken: string;
}

export class AuthClient extends ServiceClient {
  public async login(
    username: string,
    password: string,
    useRefreshTokens?: boolean,
  ): Promise<AxiosResponse<ConnectToken & Partial<ConnectRefreshToken>>> {
    return await this.httpClient.post(
      '/login',
      {
        username,
        password,
        useRefreshTokens,
      },
      {
        ...this.requestConfig,
      },
    );
  }

  public async refreshToken(refreshToken: string): Promise<AxiosResponse<ConnectToken & Partial<ConnectRefreshToken>>> {
    return await this.httpClient.post(
      '/refresh-token',
      {
        refreshToken,
      },
      {
        ...this.requestConfig,
      },
    );
  }

  public async passwordless(email: string, redirectHostname: string): Promise<AxiosResponse<void>> {
    return await this.httpClient.post(
      '/passwordless',
      {
        email,
        redirectHostname,
      },
      {
        ...this.requestConfig,
      },
    );
  }

  public async passwordlessOTP(
    email: string,
    otp: string,
  ): Promise<AxiosResponse<ConnectToken & Partial<ConnectRefreshToken>>> {
    return await this.httpClient.post(
      '/passwordless/otp',
      {
        email,
        otp,
      },
      {
        ...this.requestConfig,
      },
    );
  }
}
